import { Row, Col } from 'react-bootstrap';


function MyFooter() {
    return (
        <footer className='footer mt-auto bg-dark'>
            <div className='man-footer'>
                <div className='container'>
                    <Row>
                        <Col xs={12} md={8}>
                        <p>© 2023 Heinrich Heiden GmbH & Co.KG.<br/>
                        Webseite von <a href="mailto:info@romike-solutions.de">Romike Solutions</a></p>
                        </Col>
                        <Col xs={12} md={4}>
                            <a href="/impressum">Impressum</a><br />
                            <a href="/datenschutz">Datenschutz</a><br />
                        </Col>
                    </Row>
                </div>
            </div>
        </footer>
    );
}

export default MyFooter;